import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/index.scss';
import { App } from '@/app/App';
// last, like Angular Material's runtime-injected component styles (see material-components.scss)
import '@/styles/material-components.scss';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
